// extracted by mini-css-extract-plugin
export default {"modal":"RootModal_modal__2ybDP","likeAnimation":"RootModal_likeAnimation__+Z2dZ"};